export default {"src":"https://images-cdn.curipod.com/d-8a4f32ab/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};